import { render, staticRenderFns } from "./GameSettingsView.vue?vue&type=template&id=057c8f02&scoped=true"
import script from "./GameSettingsView.vue?vue&type=script&lang=js"
export * from "./GameSettingsView.vue?vue&type=script&lang=js"
import style0 from "./GameSettingsView.vue?vue&type=style&index=0&id=057c8f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c8f02",
  null
  
)

export default component.exports